import React from 'react';

export default function Badge({className, content}) {
  className = className || "badge-o-primary"
  return (
    <span className={"badge badge-sm ml-1 " + className}>{content}</span>
  )
}

